// extracted by mini-css-extract-plugin
export default {"wrapper":"password-change_wrapper__0DvKC","headline":"password-change_headline__L0q+z"};